import { createSelector } from "@reduxjs/toolkit";

const selectAccessCode = (state) =>
  state.providerAccountCreation?.confirmSiteAccessDetails?.accessCode;

const selectConfirmSiteAccessDetails = (state) =>
  state.providerAccountCreation?.confirmSiteAccessDetails;

const selectLocationNPI = (state) =>
  state.providerAccountCreation?.confirmSiteAccessDetails?.locationNPI;

const selectFirstName = (state) =>
  state.providerAccountCreation?.providerPersonalInfo?.firstName;

const selectEmailLanguage = (state) =>
  state.providerAccountCreation?.accountData?.emailLanguage;

const selectEmailLangCd = (state) =>
  state.providerAccountCreation?.providerPersonalInfo?.emailLangCd;

const selectMiddleName = (state) =>
  state.providerAccountCreation?.providerPersonalInfo?.middleName;

const selectLastName = (state) =>
  state.providerAccountCreation?.providerPersonalInfo?.lastName;

const selectEmail = (state) =>
  state.providerAccountCreation?.providerPersonalInfo?.email;

const selectProviderSiteLocationId = (state) =>
  state.providerAccountCreation?.providerPersonalInfo?.providerSiteLocationId;

const selectProfLicenseNo = (state) =>
  state.providerAccountCreation?.accountData?.profLicenseNo;

const selectHasProfLicenseNo = (state) =>
  state.providerAccountCreation?.accountData?.hasProfLicenseNo;

const selectDOB = (state) => state.providerAccountCreation?.accountData?.dob;

const selectUsername = (state) =>
  state.providerAccountCreation?.accountData?.username;

const selectPassword = (state) =>
  state.providerAccountCreation?.accountData?.password;

const selectUsernameApiResponse = (state) =>
  state.providerAccountCreation?.accountData?.usernameApiResponse;

const selectUserInvitationId = (state) =>
  state.providerAccountCreation?.confirmSiteAccessDetails?.userInvitationId;

const selectAccountType = (state) =>
  state.providerAccountCreation?.providerPersonalInfo?.accountType;

const selectAccountCreationStatus = (state) =>
  state.providerAccountCreation?.accountCreationStatus;

const selectSiteDetails = (state) => state.providerAccountCreation?.siteDetails;

export const manageProviderAccountCreationSelector = createSelector(
  [
    selectAccessCode,
    selectLocationNPI,
    selectFirstName,
    selectMiddleName,
    selectLastName,
    selectEmail,
    selectAccountType,
    selectProfLicenseNo,
    selectDOB,
    selectUsername,
    selectPassword,
    selectUsernameApiResponse,
    selectUserInvitationId,
    selectProviderSiteLocationId,
    selectAccountCreationStatus,
    selectConfirmSiteAccessDetails,
    selectEmailLanguage,
    selectEmailLangCd,
    selectHasProfLicenseNo,
    selectSiteDetails,
  ],
  (
    accessCode,
    locationNPI,
    firstName,
    middleName,
    lastName,
    email,
    accountType,
    profLicenseNo,
    dob,
    username,
    password,
    usernameApiResponse,
    userInvitationId,
    providerSiteLocationId,
    accountCreationStatus,
    confirmSiteAccessDetails,
    emailLanguage,
    emailLangCd,
    hasProfLicenseNo,
    siteDetails
  ) => ({
    accessCode,
    locationNPI,
    firstName,
    middleName,
    lastName,
    email,
    accountType,
    profLicenseNo,
    dob,
    username,
    password,
    usernameApiResponse,
    userInvitationId,
    providerSiteLocationId,
    accountCreationStatus,
    confirmSiteAccessDetails,
    emailLanguage,
    emailLangCd,
    hasProfLicenseNo,
    siteDetails,
  })
);
